import { gql } from "gql";

export const GET_EXTERNAL_SIGN_EGOV_LINK = gql(/* GraphQL */ `
  query GetExternalSignEgovLink($code: String!) {
    getExternalSignEgovLink(code: $code) {
      launchEgovBusinessLink
      launchEgovMobileLink
      qrCode
    }
  }
`);
